export default __webpack_public_path__ + "static/media/microphone-1.8ef999be.png";